<template>
  <b-dropdown ref="irpfDropdown" class="gk-irpf-input" toggle-class="gk-irpf-input--toggle" no-caret :disabled="disabled" @shown="focusIRPFInput">
    <template #button-content>
      <div v-show="!isExempt">
        <b-input-group class="icon-contained-input-group">
          <b-form-input name="irpf_rate" ref="IRPFRateInput" v-model="localIRPFValue" placeholder="15" size="4" type="number" id="irpf-numeric-input" step="any" required :disabled="disabled" />
          <b-input-group-append>
            <b-input-group-text>%</b-input-group-text>
          </b-input-group-append>
        </b-input-group>
      </div>
      <div v-show="isExempt">{{ $gettext("IRPF exempt") }} <span style="font-size: 14px;"><font-awesome-icon icon="fa-solid fa-caret-down" /></span></div>
    </template>
    <b-dropdown-item 
      v-for="(irpf_rate, irpf_index) in retentionRates"
      :value="irpf_rate.taxrate"
      :key="'irpf_rate-' + irpf_index"
      @click="selectIRPFRate(irpf_index)"
    >
      {{ irpf_rate.name }}
    </b-dropdown-item>
  </b-dropdown>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  name: "IRPFInput",
  props: {
    value: {
      type: [Number, String],
      default: null
    },
    defaultExempt: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
    }
  },
  computed: {
    ...mapGetters({ 
      retentionRates: "invoices/getRetentionRates"
    }),
    localIRPFValue: {
      get () { return this.value },
      set (localIRPFValue) { this.$emit('input', localIRPFValue)  }
    },
    isExempt () {
      return this.localIRPFValue === 'exempt'
    }
  },
  created () {
  },
  methods: {
    updateValue (selectedTaxRate) {
      this.$emit('input', selectedTaxRate)
    },
    focusIRPFInput () {
      this.$refs.IRPFRateInput.focus()
    },
    selectIRPFRate (irpf_index) {
      if (irpf_index === 'exempt') {
        this.localIRPFValue = irpf_index
      } else {
        this.localIRPFValue = this.retentionRates[irpf_index].taxrate
        console.log('this.localIRPFValue', this.localIRPFValue)
      }
    }
  },
}
</script>

<style lang="scss">
  .gk-irpf-input {
    &--toggle {
      padding: 0 !important;
      border: 0 !important;
      background: none !important;
      color: $colorTextBase !important;
      user-select: text !important;
      input { user-select: text !important; }
    }
    #irpf-numeric-input {
      width: 35px;
      border-right: 0;
      text-align: right;
      padding-right: 5px;
    }
    .input-group-text {
      padding: 0.25rem 0.5rem;
      padding-left: 0;
      color: $colorTextLight;
    }
  }
</style>